export default __webpack_public_path__ + "static/media/the-incredible-true-story.c7b1a11f.jpg";